<div class="background" routerLink="/login"
     routerLinkActive="blur"></div>
<div class="main-form-wrapper">
  <router-outlet></router-outlet>
</div>
